// helpers/renderCategoryList.tsx
import Image from 'next/image';
import styles from './drawerContent.module.scss';
import IconArrowRight from '@/assets/icons/drawer-icons/icon-arrow-right.svg';
import { config } from '@/apollo/config';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import Link from 'next/link';

type Category = {
  id: string;
  name: string;
  slug: string;
  icon: string;
};

type RenderCategoryListProps = {
  categories: Category[];
  handleTabSecondChange: (id: string, name: string) => void;
  tab: string;
  handleCategoryChange: (id: string) => void;
};

export const renderCategoryList = ({
  categories,
  handleTabSecondChange,
  tab,
  handleCategoryChange,
}: RenderCategoryListProps) => {
  return categories?.map(category => (
    <div
      key={category?.id}
      onClick={() => handleTabSecondChange(category.id, category.name)}
      onMouseEnter={() => handleCategoryChange(category.id)}
      className={`${styles.drawer__category} ${
        tab === category?.id ? styles.categoryActive : null
      }`}
    >
      <div className={styles.drawer__text}>
        <Image
          src={`${config.publicApiUrl}${category?.icon}`}
          alt={category.name}
          className={styles.brandLogo}
          width={20}
          height={20}
        />
        <p>{category?.name}</p>
      </div>
      <div className={styles.iconArrow}>
        <IconArrowRight />
      </div>
    </div>
  ));
};

type RenderCategorySecondListProps = {
  categories: Category[];
  closeButton: () => void;
  handleTabChange: (id: string) => void;
  isHover: string;
};

export const renderCategorySecondList = ({
  categories,
  closeButton,
  handleTabChange,
  isHover,
}: RenderCategorySecondListProps) =>
  categories?.map(item => {
    const categoryLink = `/catalog/${decodeBase64Id(item.id)}-${item.slug}`;

    return (
      <Link
        href={categoryLink}
        key={item?.id}
        onClick={closeButton}
        onMouseEnter={() => handleTabChange(item.id)}
        className={`${styles.drawer__category} ${isHover === item?.id ? styles.categoryActive : null}`}
      >
        <div className={styles.drawer__text}>
          <Image
            src={`${config.publicApiUrl}${item?.icon}`}
            alt={item.name}
            className={styles.brandLogo}
            width={20}
            height={20}
          />
          <p>{item?.name}</p>
        </div>
        <div className={styles.iconArrow}>
          <IconArrowRight />
        </div>
      </Link>
    );
  });
